import React, { useEffect, useState, useMemo } from 'react'
import IPInput from '../../../components/IPInput'
import Translations from '../../../translations'
import { translate } from '../../../base/localization'
import IPButton from '../../../components/IPButton'
import { useCustomReducer } from '../../../base/customHooks'
import {
  formatAsCurrency,
  formatDate,
  formatPriceNegatif,
} from '../../../base/utils/dataHelper'
import { GetOrdersByDealersApi } from './services/getOrdersByDealersApi'
import {
  ICompany,
  ICompony,
  ICreditState,
  ICreditStateRequest,
  IDashBoardOrderDataRequest,
  IDashBoardOrderDataResponse,
  IDashBoardSapOrderDataResponse,
  IDashboardRemainderResponse,
  IOrder,
} from './models/models'
import { GetCompanyApi } from './services/getCompanyApi'
import { GetCreditStateApi } from './services/getCreditStateApi'
import Swal from 'sweetalert2'
import {
  BaseComponentWithContextProps,
  componentWithContext,
} from '../../../base/customHooks/componentHOC'
import './style.scss'
import { GetDashboardRemainderApi } from './services/getDashboardRemainderApi'
import { DashBoardOrderDataApi } from './services/dashBoardOrderDataApi'
import Table from '../../../components/Table'
import CurrencyChart from '../../Admin/Dashboard/components/CurrencyChart'
import IPDatePicker from '../../../components/IPDatePicker'
import { DashBoardSapOrderDataApi } from './services/dashBoardSapOrderDataApi'

interface ContactState {
  buttonOrderChange: 'usd' | 'try' | 'eur'
  buttonChange: 'day' | 'month'
  buttonChannelChange: number
  data: IOrder
  dataPrice: any[]
  total: number
  totalPrice: number
  buttonPriceChange: 'usd' | 'try' | 'eur'
  total2: string
  totalPrice2: string
  index: ICompony
  despec: ICompony
  datagate: ICompony
  netex: ICompony
  companyActive: number
  currencyActive: 'USD' | 'TRY' | 'EUR'
  creditStateData?: ICreditState
  cStateData: ICreditState[]
  amountIndex: string
  amountVgaIndex: string
  amountNetex: string
  amountVgaNetex: string
  amountDatagate: string
  amountVgaDatagate: string
  amountDespec: string
  amountVgaDespec: string
  amount: string
  amountVga: string
  dashboardRemainder: IDashboardRemainderResponse[]
  orderData: IDashBoardOrderDataResponse[]
  toggleTable: boolean
  orderSapData?: IDashBoardSapOrderDataResponse
}

function Contact(props: BaseComponentWithContextProps) {
  const t = translate(Translations)

  const [data, setData] = useState<IOrder>({
    CompanyOrderDetails: [],
    componyOrdersCount: [],
    dataSapList: [],
  })

  const getInitialState = (): ContactState => ({
    buttonOrderChange: 'usd',
    buttonChange: 'day',
    buttonChannelChange: 0,
    data,
    dataPrice: [],
    total: 0,
    totalPrice: 0,
    buttonPriceChange: 'usd',
    total2: '',
    totalPrice2: '',
    index: {
      OrderPrice: 0,
      OrderCount: 0,
    },
    despec: {
      OrderPrice: 0,
      OrderCount: 0,
    },
    datagate: {
      OrderPrice: 0,
      OrderCount: 0,
    },
    netex: {
      OrderPrice: 0,
      OrderCount: 0,
    },
    companyActive: 1000,
    cStateData: [],
    currencyActive: 'USD',
    amountIndex: '',
    amountVgaIndex: '',
    amountNetex: '',
    amountVgaNetex: '',
    amountDatagate: '',
    amountVgaDatagate: '',
    amountDespec: '',
    amountVgaDespec: '',
    amount: '',
    amountVga: '',
    dashboardRemainder: [],
    orderData: [],
    toggleTable: false,
    creditStateData: undefined,
    orderSapData: undefined,
  })

  const initialStartDate = new Date()
  initialStartDate.setMonth(0)
  initialStartDate.setDate(1)
  initialStartDate.setHours(0)
  initialStartDate.setMinutes(0)
  initialStartDate.setSeconds(0)

  const [startDate, setStartDate] = useState(initialStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const [companies, setCompanies] = useState<ICompany[]>([])

  const [state, setState] = useCustomReducer<ContactState>(getInitialState())

  /**
   * Ondalık kısmı küçük yazmak için helper.
   * Örnek desteklenen formatlar:
   *  - "$10.000,00"
   *  - "-$7,69"
   *  - "10.000,00 ₺"
   *  - "1,234.56 $"
   */
  const renderAmountWithSmallDecimals = (value?: string | number) => {
    if (value === undefined || value === null) return null

    const raw = String(value).trim()
    if (!raw) return null

    // prefix (para birimi vs) + sayı benzeri kısım + suffix (para birimi vs)
    const m = raw.match(/^(\s*[+-]?\s*[^\d]*)([\d.,\s]+)(.*)$/)
    const prefix = m?.[1] ?? ''
    const numLike = (m?.[2] ?? raw).replace(/\s+/g, '')
    const suffix = m?.[3] ?? ''

    const lastComma = numLike.lastIndexOf(',')
    const lastDot = numLike.lastIndexOf('.')
    const sepIndex = Math.max(lastComma, lastDot)

    // Türkiye formatını varsay: input’ta ',' varsa ondalık ','; yoksa '.' varsa '.'; hiç yoksa ','
    const decSep =
      sepIndex === -1 ? (numLike.includes(',') ? ',' : numLike.includes('.') ? '.' : ',') : numLike[sepIndex]
    const thousandsSep = decSep === ',' ? '.' : ','

    const addThousands = (digits: string) => {
      const d = digits.replace(/[^\d]/g, '') || '0'
      return d.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep)
    }

    let intPart = ''
    let fracRaw = ''

    if (sepIndex === -1) {
      intPart = numLike
      fracRaw = ''
    } else {
      intPart = numLike.slice(0, sepIndex)
      fracRaw = numLike.slice(sepIndex + 1)
    }

    const intFormatted = addThousands(intPart)

    // her zaman 2 hane: pad + truncate
    const frac2 = (fracRaw.replace(/[^\d]/g, '') + '00').slice(0, 2)

    return (
      <span>
        {prefix}
        {intFormatted}
        {decSep}
        <span className="amount-decimal">{frac2}</span>
        {suffix}
      </span>
    )
  }



  // DashboardRemainder için ortak helper
  const applyDashboardRemainderByCurrency = (
    list: IDashboardRemainderResponse[],
    type: 'USD' | 'TRY' | 'EUR'
  ) => {
    list.forEach((res) => {
      let amount = ''
      let vga = ''

      if (type === 'USD') {
        amount = res.AmountUSD
        vga = res.AmountVgaUSD
      } else if (type === 'TRY') {
        amount = res.AmountTL
        vga = res.AmountVgaTL
      } else {
        amount = res.AmountEURO
        vga = res.AmountVgaEURO
      }

      if (res.Name === '1000') {
        setState({ amountIndex: amount, amountVgaIndex: vga })
      }
      if (res.Name === '1100') {
        setState({ amountDatagate: amount, amountVgaDatagate: vga })
      }
      if (res.Name === '1200') {
        setState({ amountDespec: amount, amountVgaDespec: vga })
      }
      if (res.Name === '2300') {
        setState({ amountNetex: amount, amountVgaNetex: vga })
      }
      if (res.Name === 'Toplam') {
        setState({ amount, amountVga: vga })
      }
    })
  }

  // Şirketleri çek
  const getCompany = async () => {
    const getCompanyApi = new GetCompanyApi({})
    const res = await getCompanyApi.getCompanies()
    if (res) setCompanies(res)
  }

  useEffect(() => {
    getCompany()
  }, [])

  // Şirketler yüklendikten sonra ilk state ayarları
  useEffect(() => {
    if (companies && companies.length > 0) {
      const defaultCurrency: 'USD' | 'TRY' | 'EUR' = props.user.IsVodafone
        ? 'TRY'
        : 'USD'
      const defaultButtonPrice: 'usd' | 'try' | 'eur' =
        defaultCurrency === 'USD' ? 'usd' : defaultCurrency === 'TRY' ? 'try' : 'eur'
      const defaultOrderMoney: 'usd' | 'try' | 'eur' =
        props.user.IsVodafone ? 'try' : 'usd'

      setState({
        companyActive: Number(companies[0].Code),
        currencyActive: defaultCurrency,
        buttonPriceChange: defaultButtonPrice,
        buttonOrderChange: defaultOrderMoney,
      })

      getOrdersByDealers(defaultOrderMoney)
      getCreditState(defaultCurrency)
      getDashboardRemainder(defaultCurrency)
      dashBoardOrderData()
    }
  }, [companies])

  // Siparişleri (SAP) çek
  const getOrdersByDealers = async (money: 'usd' | 'try' | 'eur') => {
    let sdate = formatDate(new Date())
    let edate = formatDate(new Date())
    const tarih = new Date()
    tarih.setMonth(tarih.getMonth() - 1)
    if (state.buttonChange === 'month') sdate = formatDate(tarih)

    const req = {
      DealerCode: '',
      StartDate: sdate,
      EndDate: edate,
    }

    props.showLoading()
    const dashBoardSapOrderDataApi = new DashBoardSapOrderDataApi({})

    try {
      const res = await dashBoardSapOrderDataApi.dashBoardSapOrderData(req)
      if (res) {
        setState({
          orderSapData: res,
          buttonOrderChange: money,
        })
      }
    } catch (e: any) {
      Swal.fire({
        icon: 'error',
        title: e.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  // Kredi durumu
  const getCreditState = async (type: 'USD' | 'TRY' | 'EUR') => {
    const req: ICreditStateRequest = {
      Currency: type,
    }
    const getCreditStateApi: GetCreditStateApi = new GetCreditStateApi({})
    props.showLoading()

    try {
      const result: ICreditState[] = await getCreditStateApi.getCreditState(req)
      if (result) {
        setState({
          cStateData: result,
          creditStateData: result.find(
            (cre) => +cre.Company === state.companyActive
          ),
        })
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  // Dashboard Remainder
  const getDashboardRemainder = async (defaultCurrency?: 'USD' | 'TRY' | 'EUR') => {
    props.showLoading()
    const getDashboardRemainderApi: GetDashboardRemainderApi =
      new GetDashboardRemainderApi({})

    try {
      const result: IDashboardRemainderResponse[] =
        await getDashboardRemainderApi.getDashboardRemainder()

      setState({ dashboardRemainder: result })

      const currency: 'USD' | 'TRY' | 'EUR' =
        defaultCurrency ?? (props.user.IsVodafone ? 'TRY' : 'USD')

      const button: 'usd' | 'try' | 'eur' =
        currency === 'USD' ? 'usd' : currency === 'TRY' ? 'try' : 'eur'

      setState({ buttonPriceChange: button })
      applyDashboardRemainderByCurrency(result, currency)
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  // Dashboard Remainder para birimi değiştirme (butonlar)
  const selectDashboardRemainder = (type: 'USD' | 'TRY' | 'EUR') => {
    setState({
      buttonPriceChange:
        type === 'USD' ? 'usd' : type === 'TRY' ? 'try' : 'eur',
    })
    applyDashboardRemainderByCurrency(state.dashboardRemainder, type)
  }

  const dateToISO = (date: Date) =>
    new Date(new Date(date).getTime() + 3 * 3600 * 1000)

  // Aylık sipariş grafiği verisi
  const dashBoardOrderData = async () => {
    const initialEndDate = new Date(endDate)
    initialEndDate.setMonth(initialEndDate.getMonth() + 1)
    initialEndDate.setDate(0)
    initialEndDate.setHours(23)
    initialEndDate.setMinutes(59)
    initialEndDate.setSeconds(59)

    const initialStartDate = new Date(startDate)
    initialStartDate.setDate(1)
    initialStartDate.setHours(0)
    initialStartDate.setMinutes(0)
    initialStartDate.setSeconds(0)

    const req: IDashBoardOrderDataRequest = {
      StartDate: dateToISO(initialStartDate),
      EndDate: dateToISO(initialEndDate),
    }

    const dashBoardOrderDataApi: DashBoardOrderDataApi =
      new DashBoardOrderDataApi({})

    try {
      const result: IDashBoardOrderDataResponse[] =
        await dashBoardOrderDataApi.dashBoardOrderData(req)
      setState({ orderData: result })
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  // data (IOrder) değişince company bazında toplamları güncelle
  useEffect(() => {
    setState({
      index: {
        OrderPrice: 0,
        OrderCount: 0,
      },
      datagate: {
        OrderPrice: 0,
        OrderCount: 0,
      },
      despec: {
        OrderPrice: 0,
        OrderCount: 0,
      },
      netex: {
        OrderPrice: 0,
        OrderCount: 0,
      },
    })

    let totalCount = 0
    let totalPrice = 0

    data.componyOrdersCount.forEach((com) => {
      if (
        com.Company === '1000' ||
        com.Company === '1100' ||
        com.Company === '1200' ||
        com.Company === '2300'
      ) {
        totalCount += com.OrdercountUSD
        const price = com.OrderPriceUSD * 100
        totalPrice += price

        if (com.Company === '1000') {
          setState({
            index: {
              OrderPrice: com.OrderPriceUSD,
              OrderCount: com.OrdercountUSD,
            },
          })
        }
        if (com.Company === '1100') {
          setState({
            datagate: {
              OrderPrice: com.OrderPriceUSD,
              OrderCount: com.OrdercountUSD,
            },
          })
        }
        if (com.Company === '1200') {
          setState({
            despec: {
              OrderPrice: com.OrderPriceUSD,
              OrderCount: com.OrdercountUSD,
            },
          })
        }
        if (com.Company === '2300') {
          setState({
            netex: {
              OrderPrice: com.OrderPriceUSD,
              OrderCount: com.OrdercountUSD,
            },
          })
        }
      }
    })

    totalPrice = totalPrice / 100

    setState({
      data,
      total: totalCount,
      totalPrice: totalPrice,
    })
  }, [data])

  // Şirketler + kredi verisi geldiğinde ilk aktif şirketi seç
  useEffect(() => {
    if (companies?.length > 0 && state.cStateData) {
      selectCompany(Number(companies[0].Code))
    }
  }, [companies, state.cStateData])

  const moneyChange = async (money: 'usd' | 'try' | 'eur') => {
    setState({
      index: {
        OrderPrice: 0,
        OrderCount: 0,
      },
      datagate: {
        OrderPrice: 0,
        OrderCount: 0,
      },
      despec: {
        OrderPrice: 0,
        OrderCount: 0,
      },
      netex: {
        OrderPrice: 0,
        OrderCount: 0,
      },
    })

    let totalCount = 0
    let totalPrice = 0

    data.componyOrdersCount.forEach((com) => {
      if (
        com.Company === '1000' ||
        com.Company === '1100' ||
        com.Company === '1200' ||
        com.Company === '2300'
      ) {
        let count = 0
        let price = 0

        if (money === 'usd') {
          count = com.OrdercountUSD
          price = com.OrderPriceUSD * 100
        } else if (money === 'try') {
          count = com.OrderCountTRY
          price = com.OrderPriceTRY * 100
        } else {
          count = com.OrderCountEUR
          price = com.OrderPriceEUR * 100
        }

        totalCount += count
        totalPrice += price

        const setCompanyState = (key: keyof ContactState) => {
          setState({
            [key]: {
              OrderPrice:
                money === 'usd'
                  ? com.OrderPriceUSD
                  : money === 'try'
                    ? com.OrderPriceTRY
                    : com.OrderPriceEUR,
              OrderCount:
                money === 'usd'
                  ? com.OrdercountUSD
                  : money === 'try'
                    ? com.OrderCountTRY
                    : com.OrderCountEUR,
            } as any,
          })
        }

        if (com.Company === '1000') setCompanyState('index')
        if (com.Company === '1100') setCompanyState('datagate')
        if (com.Company === '1200') setCompanyState('despec')
        if (com.Company === '2300') setCompanyState('netex')
      }
    })

    totalPrice = totalPrice / 100

    setState({
      buttonOrderChange: money,
      data,
      total: totalCount,
      totalPrice: totalPrice,
    })
  }

  const dayChange = async (date: 'day' | 'month', channel: number) => {
    let sdate = ''
    let edate = ''
    let chan: string | null = null

    if (channel === 30 || channel === 10) {
      chan = channel.toString()
    }

    if (date === 'day') {
      sdate = formatDate(new Date())
      edate = formatDate(new Date())
    } else if (date === 'month') {
      const tarih = new Date()
      tarih.setMonth(tarih.getMonth() - 1)
      sdate = formatDate(tarih)
      edate = formatDate(new Date())
    }

    const req = {
      DealerCode: '',
      StartDate: sdate,
      EndDate: edate,
      Channel: chan,
    }

    props.showLoading()
    const dashBoardSapOrderDataApi = new DashBoardSapOrderDataApi({})

    try {
      const res = await dashBoardSapOrderDataApi.dashBoardSapOrderData(req)
      if (res) {
        setState({ orderSapData: res, buttonChange: date })
      }
    } catch (e: any) {
      Swal.fire({
        icon: 'error',
        title: e.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    } finally {
      props.hideLoading()
    }
  }

  const selectCompany = async (company: number) => {
    setState({
      companyActive: company,
      creditStateData: state.cStateData.find(
        (cre) => +cre.Company === company
      ),
    })
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'col1' as const,
      },
      {
        Header: 'Ay',
        accessor: 'col2' as const,
      },
      {
        Header: 'Sipariş Adedi',
        accessor: 'col3' as const,
      },
      {
        Header: 'Tutar(TRY)',
        accessor: 'col4' as const,
      },
      {
        Header: 'Tutar(USD)',
        accessor: 'col5' as const,
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      state.orderData.map((item: IDashBoardOrderDataResponse, index: number) => ({
        col1: index + 1,
        col2:
          item.Month === 1
            ? 'Ocak'
            : item.Month === 2
              ? 'Şubat'
              : item.Month === 3
                ? 'Mart'
                : item.Month === 4
                  ? 'Nisan'
                  : item.Month === 5
                    ? 'Mayıs'
                    : item.Month === 6
                      ? 'Haziran'
                      : item.Month === 7
                        ? 'Temmuz'
                        : item.Month === 8
                          ? 'Ağustos'
                          : item.Month === 9
                            ? 'Eylül'
                            : item.Month === 10
                              ? 'Ekim'
                              : item.Month === 11
                                ? 'Kasım'
                                : 'Aralık',
        col3: item.OrderCount,
        col4: item.OrderAmountTL,
        col5: item.OrderAmountUSD,
      })),
    [state.orderData]
  )

  const orderPriceAndQuantity = (title: 'Quantity' | 'Price', value: string) => {
    const orderSapData = state.orderSapData
      ? state.orderSapData.CompanyOrderDetails.length > 0
        ? state.orderSapData.CompanyOrderDetails
        : []
      : []

    const findItem = orderSapData.find((com) => com.Name === String(value))

    let quantity: number = 0
    let priceFormatted: string =
      state.buttonOrderChange === 'usd'
        ? '0.00 $'
        : state.buttonOrderChange === 'try'
          ? '0.00 ₺'
          : '0.00 €'

    if (findItem) {
      if (title === 'Quantity') {
        quantity =
          state.buttonOrderChange === 'usd'
            ? findItem.USDCount
            : state.buttonOrderChange === 'try'
              ? findItem.TLCount
              : findItem.EUROCount
      } else {
        priceFormatted =
          state.buttonOrderChange === 'usd'
            ? findItem.USDPrice
            : state.buttonOrderChange === 'try'
              ? findItem.TLPrice
              : findItem.EUROPrice
      }
    }

    return title === 'Quantity' ? quantity : priceFormatted
  }

  const creditCurrency = state.currencyActive
  const dashboardCurrency =
    state.buttonPriceChange === 'usd'
      ? 'USD'
      : state.buttonPriceChange === 'try'
        ? 'TRY'
        : 'EUR'

  return (
    <React.Fragment>
      <h5>Kredi Limit Bilgilerim</h5>
      <nav className='currency--tab-menu'>
        <ul>
          <li
            onClick={() => {
              getCreditState('USD')
              setState({ currencyActive: 'USD' })
            }}
            className={`dropdown-submenu currency-tab ${state.currencyActive === 'USD' ? 'active-currency-tab' : ''
              }`}
          >
            <span>USD</span>
          </li>
          <li
            onClick={() => {
              getCreditState('TRY')
              setState({ currencyActive: 'TRY' })
            }}
            className={`dropdown-submenu currency-tab ${state.currencyActive === 'TRY' ? 'active-currency-tab' : ''
              }`}
          >
            <span>TRY</span>
          </li>
          <li
            onClick={() => {
              getCreditState('EUR')
              setState({ currencyActive: 'EUR' })
            }}
            className={`dropdown-submenu currency-tab ${state.currencyActive === 'EUR' ? 'active-currency-tab' : ''
              }`}
          >
            <span>EUR</span>
          </li>
        </ul>
      </nav>

      <nav className='company--tab-menu'>
        <ul>
          {companies.map((a) => (
            <li
              key={a.Id}
              onClick={() => selectCompany(Number(a.Code))}
              className={`dropdown-submenu company-tab company-tab-${a.Name} ${state.companyActive === Number(a.Code)
                ? `active-company-tab active-company-tab-${a.Name}`
                : ''
                }`}
            >
              <span>{a.Name}</span>
            </li>
          ))}
        </ul>
      </nav>

      {/* Kredi Limiti / Kullanılabilir Limit / Bakiye alanları
          -> form-control görünümünde div + küçük ondalık */}
      {state.creditStateData ? (
        <div className='row'>
          <div className='col-md-4'>
            <label className='form-label'>Kredi Limiti</label>
            <div className='form-control credit-display'>
              {renderAmountWithSmallDecimals(
                formatAsCurrency(
                  state.creditStateData.SKREDI_LIMIT +
                  state.creditStateData.MEKTUP_TOP,
                  creditCurrency
                )
              )}
            </div>
          </div>
          <div className='col-md-4'>
            <label className='form-label'>Kullanılabilir Limit</label>
            <div className='form-control credit-display'>
              {renderAmountWithSmallDecimals(
                formatAsCurrency(
                  state.creditStateData.SKREDI_LIMIT +
                  state.creditStateData.MEKTUP_TOP -
                  state.creditStateData.RPR_PB_BAK,
                  creditCurrency
                )
              )}
            </div>
          </div>
          <div className='col-md-4'>
            <label className='form-label'>Bakiye</label>
            <div className='form-control credit-display'>
              {renderAmountWithSmallDecimals(
                formatAsCurrency(
                  state.creditStateData.RPR_PB_BAK,
                  creditCurrency
                )
              )}
            </div>
          </div>
        </div>
      ) : (
        'Veri Bulunamadı'
      )}

      <div className='special-home'>
        {/* DESKTOP BUTONLAR */}
        <div className='d-none d-lg-block'>
          <div className='d-flex justify-content-between m-t-15'>
            {/* Para Birimi - Sipariş */}
            <div className='d-flex m-t-15'>
              <div className='m-r-10'>
                {state.buttonOrderChange === 'usd' ? (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='usd'
                    onClick={() => moneyChange('usd')}
                    text='USD'
                    style={{
                      backgroundColor: '#008000',
                      color: 'white',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='usd'
                    onClick={() => moneyChange('usd')}
                    text='USD'
                  />
                )}
              </div>
              <div className='m-r-10'>
                {state.buttonOrderChange === 'try' ? (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='try'
                    onClick={() => moneyChange('try')}
                    text='TRY'
                    style={{
                      backgroundColor: 'rgba(218, 41, 28)',
                      color: 'white',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='try'
                    onClick={() => moneyChange('try')}
                    text='TRY'
                  />
                )}
              </div>
            </div>

            {/* Kanal - HEPSİ / WEB / OFİS */}
            <div className='d-flex  m-t-15'>
              <div className='m-r-10'>
                {state.buttonChannelChange === 0 ? (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='all'
                    onClick={() => {
                      dayChange(state.buttonChange, 0)
                      setState({ buttonChannelChange: 0 })
                    }}
                    text='HEPSİ'
                    style={{
                      backgroundColor: 'blue',
                      color: 'white',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='all'
                    onClick={() => {
                      dayChange(state.buttonChange, 0)
                      setState({ buttonChannelChange: 0 })
                    }}
                    text='HEPSİ'
                  />
                )}
              </div>
              <div className='m-r-10'>
                {state.buttonChannelChange === 30 ? (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='b2b'
                    onClick={() => {
                      dayChange(state.buttonChange, 30)
                      setState({ buttonChannelChange: 30 })
                    }}
                    text='WEB'
                    style={{
                      backgroundColor: '#008000',
                      color: 'white',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='b2b'
                    onClick={() => {
                      dayChange(state.buttonChange, 30)
                      setState({ buttonChannelChange: 30 })
                    }}
                    text='WEB'
                  />
                )}
              </div>
              <div className='m-r-10'>
                {state.buttonChannelChange === 10 ? (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='sap'
                    onClick={() => {
                      dayChange(state.buttonChange, 10)
                      setState({ buttonChannelChange: 10 })
                    }}
                    text='OFİS'
                    style={{
                      backgroundColor: 'rgba(218, 41, 28)',
                      color: 'white',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-left'
                    name='sap'
                    onClick={() => {
                      dayChange(state.buttonChange, 10)
                      setState({ buttonChannelChange: 10 })
                    }}
                    text='OFİS'
                  />
                )}
              </div>
            </div>

            {/* Gün / Ay */}
            <div className='d-flex m-t-15'>
              <div className='m-r-10'>
                {state.buttonChange === 'day' ? (
                  <IPButton
                    className='form-control special-home-button-right'
                    name='day'
                    onClick={() => dayChange('day', state.buttonChannelChange)}
                    text='Bugün'
                    style={{
                      backgroundColor: 'rgba(218, 41, 28)',
                      color: 'white',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-right'
                    name='day'
                    onClick={() => dayChange('day', state.buttonChannelChange)}
                    text='Bugün'
                  />
                )}
              </div>
              <div className='m-r-10'>
                {state.buttonChange === 'month' ? (
                  <IPButton
                    className='form-control special-home-button-right'
                    name='month'
                    onClick={() =>
                      dayChange('month', state.buttonChannelChange)
                    }
                    text='Son 1 Ay'
                    style={{
                      backgroundColor: 'rgba(218, 41, 28)',
                      color: 'white',
                      marginLeft: '10px',
                    }}
                  />
                ) : (
                  <IPButton
                    className='form-control special-home-button-right'
                    name='month'
                    onClick={() =>
                      dayChange('month', state.buttonChannelChange)
                    }
                    text='Son 1 Ay'
                    style={{ marginLeft: '10px' }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* MOBILE BUTONLAR */}
        <div className='d-block d-lg-none'>
          <div className='d-flex row'>
            <div className='col-md-6 col-6'>
              {state.buttonChange === 'day' ? (
                <IPButton
                  className='form-control special-home-button-right'
                  name='day'
                  onClick={() => dayChange('day', state.buttonChannelChange)}
                  text='Bugün'
                  style={{
                    backgroundColor: 'rgba(218, 41, 28)',
                    color: 'white',
                  }}
                />
              ) : (
                <IPButton
                  className='form-control special-home-button-right'
                  name='day'
                  onClick={() => dayChange('day', state.buttonChannelChange)}
                  text='Bugün'
                />
              )}
            </div>
            <div className='col-md-6 col-6'>
              {state.buttonChange === 'month' ? (
                <IPButton
                  className='form-control special-home-button-right'
                  name='month'
                  onClick={() => dayChange('month', state.buttonChannelChange)}
                  text='Son 1 Ay'
                  style={{
                    backgroundColor: 'rgba(218, 41, 28)',
                    color: 'white',
                  }}
                />
              ) : (
                <IPButton
                  className='form-control special-home-button-right'
                  name='month'
                  onClick={() => dayChange('month', state.buttonChannelChange)}
                  text='Son 1 Ay'
                />
              )}
            </div>
          </div>
          <div className='d-flex m-t-15 overflow-x-scroll'>
            <div className='m-r-10'>
              {state.buttonOrderChange === 'usd' ? (
                <IPButton
                  className='form-control special-home-button-left'
                  name='usd'
                  onClick={() => moneyChange('usd')}
                  text='USD'
                  style={{
                    backgroundColor: '#008000',
                    color: 'white',
                  }}
                />
              ) : (
                <IPButton
                  className='form-control special-home-button-left'
                  name='usd'
                  onClick={() => moneyChange('usd')}
                  text='USD'
                />
              )}
            </div>
            <div className='m-r-10'>
              {state.buttonOrderChange === 'try' ? (
                <IPButton
                  className='form-control special-home-button-left'
                  name='try'
                  onClick={() => moneyChange('try')}
                  text='TRY'
                  style={{
                    backgroundColor: 'rgba(218, 41, 28)',
                    color: 'white',
                  }}
                />
              ) : (
                <IPButton
                  className='form-control special-home-button-left'
                  name='try'
                  onClick={() => moneyChange('try')}
                  text='TRY'
                />
              )}
            </div>
          </div>
        </div>

        {/* Sipariş Sayı / Tutar Tablosu */}
        <div
          style={{
            border: '1px solid #F0F0F1',
            backgroundColor: 'white',
            padding: '20px',
          }}
        >
          <div className='row'>
            <div className='col-lg-6 col-12'>
              <b className='d-block table-title'>Sipariş Sayıları</b>
              <table className='table table-bordered d-sm-block d-lg-table table-responsive dataTable XmlTable'>
                <tbody>
                  <tr role='row'>
                    <td
                      style={{
                        width: '100px',
                        backgroundColor: '#F1F2F2',
                        height: 300,
                      }}
                      rowSpan={companies.length + 1}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          height: (companies.length - 1) * 75 + 'px',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          style={{ fontWeight: 500, color: '#616161' }}
                        >
                          Toplam
                        </span>
                        <p
                          style={{
                            fontSize: '1.3rem',
                            color: '#00A843',
                            fontWeight: 600,
                          }}
                        >
                          {orderPriceAndQuantity('Quantity', 'Toplam')}
                        </p>
                      </div>
                    </td>
                  </tr>
                  {companies
                    .filter((com) => com.Name !== 'Index Group')
                    .map((c) => (
                      <tr className='' key={c.Id}>
                        <td style={{ verticalAlign: 'middle' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <span
                              style={{
                                color: '#676767',
                                fontWeight: 500,
                              }}
                            >
                              {c.Name}
                            </span>
                            <p
                              style={{
                                fontSize: '1.3rem',
                                color: '#00A843',
                                fontWeight: 600,
                                marginBottom: 0,
                                wordBreak: 'break-word',
                              }}
                            >
                              {orderPriceAndQuantity(
                                'Quantity',
                                String(c.Code)
                              )}
                            </p>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className='col-12 col-lg-6'>
              <b className='d-block table-title'>Sipariş Tutarları</b>
              <table className='table table-bordered d-sm-block d-lg-table dataTable table-responsive XmlTable'>
                <tbody>
                  <tr role='row'>
                    <td
                      style={{
                        width: '100px',
                        backgroundColor: '#F1F2F2',
                        height: 300,
                      }}
                      rowSpan={companies.length + 1}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          height: (companies.length - 1) * 75 + 'px',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          style={{ fontWeight: 500, color: '#616161' }}
                        >
                          Toplam
                        </span>
                        <p
                          style={{
                            fontSize: '1.3rem',
                            color: '#00A843',
                            fontWeight: 600,
                          }}
                        >
                          {renderAmountWithSmallDecimals(
                            orderPriceAndQuantity('Price', 'Toplam')
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                  {companies
                    .filter((com) => com.Name !== 'Index Group')
                    .map((c) => (
                      <tr className='' key={c.Id}>
                        <td style={{ verticalAlign: 'middle' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <span
                              style={{
                                color: '#676767',
                                fontWeight: 500,
                              }}
                            >
                              {c.Name}
                            </span>
                            <p
                              style={{
                                fontSize: '1.3rem',
                                color: '#00A843',
                                fontWeight: 600,
                                marginBottom: 0,
                                wordBreak: 'break-word',
                              }}
                            >
                              {renderAmountWithSmallDecimals(
                                orderPriceAndQuantity('Price', c.Code)
                              )}
                            </p>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Kredi Durumu / VGA Para Birimi Seçimi */}
        <div className='d-flex justify-content-between m-t-15 overflow-x-scroll'>
          <div className='d-flex m-t-15'>
            <div className='m-r-10'>
              {state.buttonPriceChange === 'usd' ? (
                <IPButton
                  className='form-control special-home-button-left'
                  name='usd'
                  onClick={() => selectDashboardRemainder('USD')}
                  text='USD'
                  style={{
                    backgroundColor: '#008000',
                    color: 'white',
                  }}
                />
              ) : (
                <IPButton
                  className='form-control special-home-button-left'
                  name='usd'
                  onClick={() => selectDashboardRemainder('USD')}
                  text='USD'
                />
              )}
            </div>
            <div className='m-r-10'>
              {state.buttonPriceChange === 'try' ? (
                <IPButton
                  className='form-control special-home-button-left'
                  name='try'
                  onClick={() => selectDashboardRemainder('TRY')}
                  text='TRY'
                  style={{
                    backgroundColor: 'rgba(218, 41, 28)',
                    color: 'white',
                  }}
                />
              ) : (
                <IPButton
                  className='form-control special-home-button-left'
                  name='try'
                  onClick={() => selectDashboardRemainder('TRY')}
                  text='TRY'
                />
              )}
            </div>
          </div>
        </div>

        {/* Kredi Durumum & VGA Tablosu */}
        <div
          style={{
            border: '1px solid #F0F0F1',
            backgroundColor: 'white',
            padding: '20px',
          }}
        >
          <div className='row '>
            <div className='col-12 col-lg-6'>
              <b className='d-block table-title'>Kredi Durumum</b>
              <table className='table table-bordered d-sm-block d-lg-table table-responsive dataTable XmlTable'>
                <tbody>
                  <tr role='row'>
                    <td
                      style={{
                        width: '100px',
                        backgroundColor: '#F1F2F2',
                        height: 300,
                      }}
                      rowSpan={companies.length + 1}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          height: companies.length * 75 + 'px',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          style={{ fontWeight: 500, color: '#616161' }}
                        >
                          Toplam
                        </span>
                        <p
                          style={{
                            fontSize: '1.3rem',
                            color: '#00A843',
                            fontWeight: 600,
                          }}
                        >
                          {renderAmountWithSmallDecimals(
                            formatPriceNegatif(state.amount, dashboardCurrency)
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                  {companies
                    .filter((com) => com.Name !== 'Index Group')
                    .map((c) => (
                      <tr className='' key={c.Id}>
                        <td style={{ verticalAlign: 'middle' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <span
                              style={{
                                color: '#676767',
                                fontWeight: 500,
                              }}
                            >
                              {c.Name}
                            </span>
                            <p
                              style={{
                                fontSize: '1.3rem',
                                color: '#00A843',
                                fontWeight: 600,
                                marginBottom: 0,
                                wordBreak: 'break-word',
                              }}
                            >
                              {c.Name === 'Index'
                                ? renderAmountWithSmallDecimals(
                                  formatPriceNegatif(
                                    state.amountIndex,
                                    dashboardCurrency
                                  )
                                )
                                : c.Name === 'Datagate'
                                  ? renderAmountWithSmallDecimals(
                                    formatPriceNegatif(
                                      state.amountDatagate,
                                      dashboardCurrency
                                    )
                                  )
                                  : c.Name === 'Despec'
                                    ? renderAmountWithSmallDecimals(
                                      formatPriceNegatif(
                                        state.amountDespec,
                                        dashboardCurrency
                                      )
                                    )
                                    : renderAmountWithSmallDecimals(
                                      formatPriceNegatif(
                                        state.amountNetex,
                                        dashboardCurrency
                                      )
                                    )}
                            </p>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className='col-12 col-lg-6'>
              <b className='d-block table-title'>VGA</b>
              <table className='table table-bordered d-sm-block d-lg-table table-responsive dataTable XmlTable'>
                <tbody>
                  <tr role='row'>
                    <td
                      style={{
                        width: '100px',
                        backgroundColor: '#F1F2F2',
                        height: 300,
                      }}
                      rowSpan={companies.length + 1}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          height: companies.length * 75 + 'px',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <span
                          style={{ fontWeight: 500, color: '#616161' }}
                        >
                          Toplam
                        </span>
                        <p
                          style={{
                            fontSize: '1.3rem',
                            color: '#00A843',
                            fontWeight: 600,
                          }}
                        >
                          {renderAmountWithSmallDecimals(
                            formatPriceNegatif(state.amountVga, dashboardCurrency)
                          )}
                        </p>
                      </div>
                    </td>
                  </tr>
                  {companies
                    .filter((com) => com.Name !== 'Index Group')
                    .map((c) => (
                      <tr className='' key={c.Id}>
                        <td style={{ verticalAlign: 'middle' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <span
                              style={{
                                color: '#676767',
                                fontWeight: 500,
                              }}
                            >
                              {c.Name}
                            </span>
                            <p
                              style={{
                                fontSize: '1.3rem',
                                color: '#00A843',
                                fontWeight: 600,
                                marginBottom: 0,
                                wordBreak: 'break-word',
                              }}
                            >
                              {c.Name === 'Index'
                                ? renderAmountWithSmallDecimals(
                                  formatPriceNegatif(
                                    state.amountVgaIndex,
                                    dashboardCurrency
                                  )
                                )
                                : c.Name === 'Datagate'
                                  ? renderAmountWithSmallDecimals(
                                    formatPriceNegatif(
                                      state.amountVgaDatagate,
                                      dashboardCurrency
                                    )
                                  )
                                  : c.Name === 'Despec'
                                    ? renderAmountWithSmallDecimals(
                                      formatPriceNegatif(
                                        state.amountVgaDespec,
                                        dashboardCurrency
                                      )
                                    )
                                    : renderAmountWithSmallDecimals(
                                      formatPriceNegatif(
                                        state.amountVgaNetex,
                                        dashboardCurrency
                                      )
                                    )}
                            </p>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Tarih Seçici + Göster / Tablo Göster-Kaldır */}
        <div className='row mt-4'>
          <div className='col-12 col-md-3 mb-3'>
            <IPDatePicker
              selected={startDate}
              // @ts-ignore
              onChange={([start, end]) => {
                setStartDate(start)
                setEndDate(end)
              }}
              // @ts-ignore
              selectsRange
              startDate={startDate}
              endDate={endDate}
              dateFormat='MM/yyyy'
              minDate={new Date('2016')}
              maxDate={new Date()}
              showMonthYearPicker
            />
          </div>
          <div className='col-12 col-md-2 mt-1 mb-3'>
            <button
              type='button'
              style={{ width: '100%' }}
              onClick={dashBoardOrderData}
              className='btn btn-success'
            >
              {t(
                'pages.admin.dealerAndOrderReport.siteNavigationStatistics.statisticsList.show'
              )}
            </button>
          </div>
          <div className='col-12 col-md-3 mt-1 mb-3'>
            <button
              type='button'
              onClick={() => {
                setState({ toggleTable: !state.toggleTable })
              }}
              className='btn btn-success'
            >
              Tabloyu {state.toggleTable ? 'Kaldır' : 'Göster'}
            </button>
          </div>
        </div>

        {/* Grafik + Tablo */}
        {state.orderData.length > 0 && (
          <div className='col-12'>
            <h5>Toplam Sipariş</h5>
            <CurrencyChart data={state.orderData} />
          </div>
        )}

        {state.toggleTable && (
          <div className='col-12'>
            <div className='row '>
              <Table columns={tableColumns} data={tableData} currentPage={0} />
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default componentWithContext(Contact)
